import createDecorator from "final-form-calculate"

const uploadFileDecorator = () => {
  return {
    field: "typeOfDocument",
    updates: {
      typeOfDocument: (value) => {
        return value ? value : null
      },
      documentPages: (_ignoredValue, allValues) => {
        const documentPages = allValues.documentPages ? allValues.documentPages : [undefined] //to generate the first upload empty line

        return allValues?.typeOfDocument ? documentPages : null
      }
    }
  }
}

export default () => {
  return createDecorator(uploadFileDecorator())
}
